import { MetricConverter } from './helpers';

const DigitalUnits = ['B', 'kB', 'MB', 'GB', 'TB'] as const;
type TDigitalUnit = (typeof DigitalUnits)[number];

class DigitalConverter extends MetricConverter<TDigitalUnit, 'B'> {
    baseUnit = 'B' as const;
    units = DigitalUnits;
}

export const digitalConverter = new DigitalConverter();
